import { observer } from 'mobx-react-lite';
import React, { ReactElement } from 'react';
import { nominationStepper, NominationStepperInstance } from '../nomination-stepper';

interface NominationWizardSectionProps {
  render: (stepper: NominationStepperInstance) => ReactElement;
}

const NominationWizardSectionImpl: React.FC<NominationWizardSectionProps> = (props) => {
  const {
    render,
  } = props;

  const stepper = nominationStepper.useStepper();

  return render(stepper);
};

export const NominationWizardSection = observer(NominationWizardSectionImpl);
